import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { PawPrint, ArrowRight } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import Team from "../components/home/Team";
import Reveal from "../components/Reveal";

const members = [
  { role: "Owner", name: "Kirstie", img: "staff_kirstie.png", pos: "16% 28%" },
  { role: "Manager", name: "Jake", img: "staff_jake.png", pos: "50% 20%" },
  { role: "Clinical Director & Veterinary Surgeon", name: "Nadia", img: "staff_nadia.png", pos: "70% 25%" },
  { role: "Registered Veterinary Nurse (RVN)", name: "Rebecca", img: "staff_rebecca.png", pos: "35% 30%" },
  { role: "Veterinary Care Assistant", name: "Stephanie", img: "staff_stephanie.png", pos: "45% 20%" },
];

const OurTeam = () => {
  useEffect(() => {
    document.title = "Our Team – Moggies & Doggies Veterinary Care";
  }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="Our Team"
          subtitle="Meet the Compassionate Experts Behind Moggies & Doggies Veterinary Care"
          crumbs={["Our Team"]}
        />

        {/* Intro */}
        <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <Reveal animation="fadeInLeft" className="relative">
              <img src="/pawelle/img_16.jpg" alt="Our veterinary team" className="w-full rounded-[28px] object-cover shadow-[0_24px_60px_rgba(67,48,109,0.12)]" />
              <div className="absolute -bottom-6 -right-4 flex flex-col items-center justify-center rounded-[24px] bg-pawelle-primary px-8 py-6 text-center text-white shadow-[0_18px_40px_rgba(114,82,155,0.3)]">
                <span className="font-display text-[40px] font-bold leading-none">25+</span>
                <span className="mt-1 font-body text-[14px] font-semibold text-white/90">Years of Experience</span>
              </div>
            </Reveal>
            <div>
              <Reveal animation="rubberBand">
                <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
                  <PawPrint className="h-5 w-5" /> Our Team
                </span>
              </Reveal>
              <Reveal animation="fadeInUp" delay={100}>
                <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
                  Compassionate Vets and Nurses You Can Always Trust
                </h2>
              </Reveal>
              <Reveal animation="fadeInUp" delay={150}>
                <p className="mt-5 font-body text-[16px] leading-relaxed text-pawelle-body">
                  Libero letius aenean auctor tincidunt convallis massa turpis dolor egestas sollicitudin. Mattis
                  magnis dui arcu himenaeos vehicula consequat ex. Accumsan eleifend rutrum pellentesque letius netus
                  augue interdum iaculis proin.
                </p>
              </Reveal>
              <Reveal animation="fadeInUp" delay={200}>
                <h4 className="mt-6 font-display text-[20px] font-semibold text-pawelle-ink">Skilled Hands with Caring Hearts</h4>
                <p className="mt-2 font-body text-[16px] leading-relaxed text-pawelle-body">
                  Mus vulputate nascetur proin arcu eget aptent tempus. Potenti mi condimentum commodo fringilla pretium.
                </p>
              </Reveal>
            </div>
          </div>
        </section>

        <Team members={members} showBanner={false} />

        {/* Join team */}
        <section className="mx-auto max-w-[1290px] px-5 pb-24">
          <Reveal animation="zoomIn" className="relative overflow-hidden rounded-[32px] bg-pawelle-bg px-8 py-16 text-center">
            <PawPrint className="pointer-events-none absolute left-8 top-8 h-20 w-20 text-white opacity-70" />
            <PawPrint className="pointer-events-none absolute bottom-8 right-10 h-16 w-16 text-white opacity-70" />
            <span className="relative inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
              <PawPrint className="h-5 w-5" /> Join Our Team
            </span>
            <h2 className="relative mx-auto mt-4 max-w-2xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
              Join the Moggies & Doggies Team of Compassionate Experts
            </h2>
            <p className="relative mx-auto mt-3 max-w-xl font-body text-[16px] text-pawelle-body">
              Be part of a dedicated group that believes in healing with heart and purpose.
            </p>
            <Link
              to="/gb/en/contact-us.html"
              className="relative mt-8 inline-flex items-center gap-2 rounded-full bg-pawelle-primary px-8 py-4 font-display text-[16px] font-medium text-white transition-all duration-300 hover:bg-pawelle-primary-dark hover:-translate-y-0.5"
            >
              View Open Positions <ArrowRight className="h-5 w-5" />
            </Link>
          </Reveal>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default OurTeam;
